// extracted by mini-css-extract-plugin
module.exports = {"circle":"styles_circle__1t0zg","circleOver":"styles_circleOver__3iOoC"};